export default function toggleClass(element, className, state) {
    element.classList[state === true ? "add" : "remove"](className);
}
